<div>{{ totalStock$ | async }}</div>
